<template>
    <div class="home">
        <HeaderSivoaVue />

        <div class="home_menu_background_image">

            <div><img src="./images/Home/slogan1.png" style="margin-top: 25px;" alt="slogan1" width="242px" height="20px"></div>
            <div class="home_menu_slogan">L'&Eacute;DUCATION &Agrave; L'ENVIRONNEMENT</div>
            <div class="home_menu_slogan" style="margin-bottom: 95px;">AU SYNDICAT DE L'ORGE</div>


            <div class="w3-row" style="margin-bottom: 38px;">
                <div class="w3-cell w3-cell-middle"><img src="./images/Home/danger.png" alt="danger" /></div>
                <div class="w3-cell w3-cell-middle w3-container">
                    <div id="text1">INSCRIPTION R&Eacute;SERV&Eacute;E AUX ENSEIGNANTS</div>
                    <div id="text2">DU TERRITOIRE DU SYNDICAT DE L'ORGE</div>
                </div>

                <div style="padding-left: 10px;">
                    <a href="https://www.syndicatdelorge.fr/espace-enseignants/pdf/Carte_territoire_2022.pdf" target="_blank">
                    <img src="./images/Home/boussole_carte.png" alt="boussole_carte" style="height: 32px; width: 32px;"/>
                    <span class="home_boussole_carte">VOIR LA CARTE</span>
                    </a>
                </div>

            </div>

            <div class="w3-row">
                <div class="w3-third w3-mobile">
                    <div class="home_menu_choices_menu_cell_1">
                        <div class="home_menu_choices_menu1" style="width:360px;">
                            <div class="home_menu_title1">ATELIERS</div>
                            <div class="home_menu_title2">CYCLE 2</div>
                            <div id="text5">1 ou 2 ATELIERS</div>
                            <div class="home_menu_choices_inscription">
                                <img src="./images/Home/inscription.svg" alt="inscription" width="20px" height="20px" />
                                <div>
                                    <div id="text7">Inscription en septembre</div>
                                    <div id="text22">(nombre d'inscriptions limit&eacute;es)</div>
                                </div>
                            </div>
                            <br>
                            <div>
                                <div id="text23">CONDITION</div>
                                <div>
                                    <div><strong>&#8226;</strong>&nbsp;<strong>2 classes maximum par &eacute;cole</strong></div>
                                </div>
                            </div>
                            <div style="height: 150px;"></div>
                            <div class="menu_buttons">
                                <div id="text8">ATELIERS CYCLE 2 (CP - CE1 - CE2)</div>
                                <div class="menu_button">
                                    <div class="menu_button_text_worshops" style="color: red;">INSCRIPTIONS CL&Ocirc;TUR&Eacute;ES</div>
                                    <!-- TODO CL
                                    <router-link to="/workshops_cycle_2">
                                    <div class="menu_button_text_worshops">FORMULAIRE D'INSCRIPTION</div>
                                    </router-link>
                                    -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w3-third w3-mobile">
                    <div class="home_menu_choices_menu_cell_2">
                        <div class="home_menu_choices_menu2" style="width:360px;">
                            <div class="home_menu_title1">ATELIERS</div>
                            <div class="home_menu_title2">CYCLE 3</div>
                            <div id="text12">1 &Agrave; 5 ATELIERS</div>
                            <div class="home_menu_choices_inscription">
                                <img src="./images/Home/inscription.svg" alt="inscription" width="20px" height="20px" />
                                <div>
                                    <div id="text14">Inscription en septembre</div>
                                    <div id="text22">(nombre d'inscriptions limit&eacute;es)</div>
                                </div>
                            </div>
                            <br>
                            <br>
                            <div>
                                <div id="text23">CONDITIONS</div>
                                <div>
                                    <div><strong>&#8226;</strong>&nbsp;<strong>4 classes maximum par &eacute;cole</strong></div>
                                    <div><strong>&#8226;</strong>&nbsp;<strong>5 ateliers maximum :</strong></div>
                                    <div>&nbsp;<span style="margin-left: 10px; font-size: 13px;">3 en classe et 2 sur le terrain.</span></div>
                                </div>
                            </div>
                            <div style="height: 85px;"></div>
                            <div class="menu_buttons">
                                <div id="text16">ATELIERS CYCLE 3 (CM1- CM2)</div>
                                <div class="menu_button">
                                    <div class="menu_button_text_water_class" style="color: red;">INSCRIPTIONS CL&Ocirc;TUR&Eacute;ES</div>
                                    <!-- TODO CL
                                    <router-link to="/workshops_cycle_3">
                                    <div class="menu_button_text_water_class">FORMULAIRE D'INSCRIPTION</div>
                                    </router-link>
                                    -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w3-third w3-mobile">
                    <div class="home_menu_choices_menu_cell_3">
                        <div class="home_menu_choices_menu3" style="width:360px;">
                            <div class="home_menu_title1">MODULES</div>
                            <div class="home_menu_title2">COLL&Egrave;GE</div>
                            <div id="text19">5 MODULES AU CHOIX</div>
                            <br>
                            <div class="home_menu_choices_inscription">
                                <img src="./images/Home/inscription.svg" alt="inscription" width="20px" height="20px" />
                                <div>
                                    <div id="text20">Inscription en septembre</div>
                                    <div id="text22">(nombre d'inscriptions limit&eacute;es)</div>
                                </div>
                            </div>
                            <br>
                            <div>
                                <div id="text23">CONDITION</div>
                                <div>
                                    <div><strong>&#8226;</strong>&nbsp;<strong>6 heures maximum par classe</strong></div>
                                </div>
                            </div>
                            <div style="height: 130px;"></div>
                            <div class="menu_buttons">
                                <div id="text21">MODULES COLL&Egrave;GE</div>
                                <div class="menu_button">
                                    <!-- TODO CL
                                    <div class="menu_button_text_modules_college" style="color: red;">INSCRIPTIONS CL&Ocirc;TUR&Eacute;ES</div>
                                    -->
                                    <router-link to="/modules_college">
                                    <div class="menu_button_text_modules_college">FORMULAIRE D'INSCRIPTION</div>
                                    </router-link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="w3-row">
            <div class="w3-half w3-mobile">
                <div class="w3-display-container" style="height:240px;">
                    <div class="w3-display-bottommiddle">
                        <img src="./images/Home/couv depliant.jpg" alt="depliant" width="503px" height="212px"/>
                    </div>
                </div>
            </div>
            <div class="w3-quarter w3-mobile">
                <div class="w3-display-container" style="height:240px;">
                    <div class="w3-display-middle">
                        <a href="./pdf/DEPLIANT ECOLE.pdf" target="_blank"><img src="./images/Home/ecole_elementaire.png" alt="ecole_elementaire" width="130px" height="130px"/></a>
                    </div>
                </div>
            </div>
            <div class="w3-quarter w3-mobile">
                <div class="w3-display-container" style="height:240px;">
                    <div class="w3-display-middle">
                        <a href="./pdf/DEPLIANT COLLEGE.pdf" target="_blank"><img src="./images/Home/college.png" alt="college" width="130px" height="130px" /></a>
                    </div>
                </div>
            </div>
        </div>

        <FooterSivoaVue />
    </div>
</template>

<script>
    import HeaderSivoaVue from './HeaderSivoa.vue';
    import FooterSivoaVue from './FooterSivoa.vue';

    export default {
        name: 'home_vue',
        data() {
            return {
                //display_info_text: 0,
            }
        },
        components: {
            HeaderSivoaVue,
            FooterSivoaVue
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a {
        text-decoration: none;
    }

    .home {
        padding-left: 37px;
        padding-right: 37px;
    }

    .home_menu_background_image {
        width: 100%;
        height: auto;
        background-image: url('./images/Home/bulle.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #C5DCF3;
    }

    .home_menu {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        margin-left: 37px;
        margin-right: 37px;
        margin-top: 37px;
        margin-bottom: 37px;
        background-image: url("./images/Home/bulle.png");
        padding-top: 208px;
        padding-bottom: 20px;
    }

    /*.home_menu_warning {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        padding-bottom: 40px;
        margin-left:0px;
    }*/

    .home_menu_warning_text {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .home_menu_choices {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: stretch;
        margin-left: 37px;
        margin-right: 37px;
        flex-wrap: wrap;
    }

    .home_menu_choices_menu_cell_1 {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .home_menu_choices_menu_cell_2 {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .home_menu_choices_menu_cell_3 {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .home_menu_choices_menu1 {
        padding: 20px;
        background: #0A71B3;
        background: rgba(10, 113, 179, 1);
        border-radius: 30px;
        -moz-border-radius: 30px;
        -webkit-border-radius: 30px;
    }

    .home_menu_choices_menu2 {
        padding: 20px;
        background: #97BF0D;
        background: rgba(151, 191, 13, 1);
        border-radius: 30px;
        -moz-border-radius: 30px;
        -webkit-border-radius: 30px;
    }

    .home_menu_choices_menu3 {
        padding: 20px;
        background: #EC7404;
        background: rgba(236, 116, 4, 1);
        border-radius: 30px;
        -moz-border-radius: 30px;
        -webkit-border-radius: 30px;
    }

    .menu_buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .menu_button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        -moz-border-radius: 10px;
        -webkit-border-radius: 10px;
        margin-top: 10px;
        margin-bottom: 10px;
        width: 270px;
        height: 40px;
    }

    .menu_button_text_worshops {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 17px;
        line-height: 22.78px;
        text-transform: uppercase;
        color: #0A71B3;
        color: rgb(10, 113, 179);
        padding-top: 14px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 14px;
    }

    .menu_button_text_water_class {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 17px;
        line-height: 22.78px;
        text-transform: uppercase;
        color: #97BF0D;
        color: rgb(151, 191, 13);
        padding-top: 14px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 14px;
    }

    .menu_button_text_modules_college {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 17px;
        line-height: 22.78px;
        text-transform: uppercase;
        color: #EC7404;
        color: rgb(236, 116, 4);
        padding-top: 14px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 14px;
    }



    /*.home_footer {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
    }*/

    .leaflet_text_container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .leaflet_text {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 16px;
        text-transform: uppercase;
        color: #6C382A;
        color: rgb(108, 56, 42);
    }


    #text1, #text2 {
        font-family: Arial;
        font-size: 16px;
        text-transform: uppercase;
        color: #009AA3;
    }

    .home_menu_title1 {
        font-family: 'Quicksand', sans-serif;
        font-size: 20px;
        text-transform: uppercase;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
    }

    .home_menu_title2  {
        font-family: 'Quicksand', sans-serif;
        font-weight: bold;
        font-size: 38px;
        letter-spacing: 0.38px;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
        padding-bottom: 20px;
    }

    #text5, #text6, #text12, #text19 {
        font-family: Arial;
        font-weight: bold;
        font-size: 19px;
        text-transform: uppercase;
        color: #000000;
        color: rgb(0, 0, 0);
    }

    #text7, #text14, #text20 {
        font-family: Arial;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
        margin-left: 10px;
    }

    #text8, #text9, #text16, #text21 {
        font-family: Arial;
        font-weight: bold;
        font-size: 15px;
        text-transform: uppercase;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
    }

    #text13 {
        font-family: Arial;
        font-weight: bold;
        font-size: 14px;
        text-transform: uppercase;
        color: #000000;
        color: rgb(0, 0, 0);
        padding-bottom: 4px;
    }

    #text15 {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 14px;
        line-height: 11.39px;
        text-transform: uppercase;
        color: #97BF0D;
        color: rgb(151, 191, 13);
    }

    #text22 {
        font-family: Arial;
        font-weight: normal;
        font-size: 14px;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
    }

    #text23 {
        font-family: Arial;
        font-weight: bold;
        font-size: 15px;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
    }


    .home_menu_choices_inscription {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 10px;
    }

    .home_menu_slogan {
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: bold;
        font-size: 36px;
        text-transform: uppercase;
        color: #6C382A;
        color: rgb(108, 56, 42);
    }


    .home_boussole_carte {
        margin: 10px;
        font-family: Arial;
        font-size: 16px;
        text-transform: uppercase;
        color: #6C382A;
        color: rgb(108, 56, 42);
    }

</style>
